// One deliverable on the ContentIQ Home (or any future wizard's "what do
// you want to create" grid): tinted card in the deliverable's hue family,
// icon tile, depth dots OR a lock line, and a Create action.
//
// Props:
//   hue: { main, tint, border, deep, text, dim }   — a wizardTheme.HUES entry
//   icon: ReactNode (an inline SVG, stroke '#ffffff')
//   title, description: strings
//   depth?: { filled, total, label }               — spine-depth indicator
//   locked?: { label }                             — approval-gated line (instead of depth)
//   cta: { label, onClick }
import React from 'react';
import { FONTS, RADII, STATE, buttonDisabled } from '../utils/wizardTheme';

function LockIcon({ color }) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color}
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

export default function DeliverableCard({ hue, icon, title, description, depth, locked, cta }) {
  return (
    <div style={{
      background: hue.tint, border: `1px solid ${hue.border}`, borderRadius: RADII.card,
      padding: '22px', display: 'flex', flexDirection: 'column', gap: '12px',
    }}>
      <div style={{
        width: '42px', height: '42px', borderRadius: RADII.tile, background: hue.main,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {icon}
      </div>
      <div style={{ fontFamily: FONTS.display, fontSize: '18px', fontWeight: 600, color: hue.deep }}>
        {title}
      </div>
      <div style={{ fontSize: '12.5px', color: hue.text, lineHeight: 1.55, flexGrow: 1 }}>
        {description}
      </div>
      {depth && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {Array.from({ length: depth.total }, (_, i) => (
            <span key={i} style={{
              width: '8px', height: '8px', borderRadius: '4px',
              background: i < depth.filled ? hue.main : hue.dim,
            }} />
          ))}
          <span style={{ fontSize: '11px', color: hue.main, marginLeft: '4px', fontWeight: 600 }}>
            {depth.label}
          </span>
        </div>
      )}
      {locked && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <LockIcon color={STATE.gate.main} />
          <span style={{ fontSize: '11px', color: STATE.gate.main, fontWeight: 600 }}>
            {locked.label}
          </span>
        </div>
      )}
      {/* cta.disabled (2026-10-15): a lane that is modeled but not yet
          built keeps its card with an honest, inert button. */}
      <button onClick={cta.disabled ? undefined : cta.onClick} disabled={!!cta.disabled} style={{
        background: hue.main, color: '#ffffff', border: 'none', borderRadius: RADII.control,
        padding: '9px 0', fontSize: '13px', fontWeight: 600,
        cursor: 'pointer', fontFamily: FONTS.body,
        ...(cta.disabled ? buttonDisabled : {}),
      }}>
        {cta.label}
      </button>
    </div>
  );
}
